export default "__VITE_ASSET__Bz3$oMXx__"